<div class="row animated fadeIn">
    <div class="col-md-12">
        <div class="d-flex justify-content-between align-items-center mb-2">
            <h4 class="mb-0"><a href="javascript:void(0);" routerLink="/project/projectlist"><span
                        class="mdi mdi-arrow-left"></span></a> Project Details</h4>

        </div>
        <div class="card">
            <div class="card-body new-detail-page">
                <div
                    class="mt-3 mb-3 border-bottom w-100 d-flex flex-wrap justify-content-between align-items-center pb-2">
                    <h5 class="text-green mb-0">Project Details</h5>

                    <div class="mb-md-0 pt-1">
                        <button type="button" class="btn btn-outline-info" (click)="openClosefun()">
                            <span *ngIf="!isCollapsed"><i class="mdi mdi-chevron-down"></i></span>
                            <span *ngIf="isCollapsed"><i class="mdi mdi-chevron-up"></i></span>
                        </button>
                    </div>

                </div>
                <form [formGroup]="registerForm">
                    <div class="form-row odd">
                        <div class="form-group col-lg-4 col-sm-12">
                            <div class="row">
                                <label class="col-sm-4 col col-form-label">Project Id:</label>
                                <div class="col-sm-8 col">
                                    <input type="text" readonly class="form-control-plaintext font-weight-bold"
                                        formControlName="ProjectId">
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-lg-4 col-sm-12">
                            <div class="row">
                                <label class="col-sm-4 col col-form-label">Project Name:</label>
                                <div class="col-sm-8 col">
                                    <p class="mb-0 pt-2 font-weight-bold">{{comdata?.ProjectName}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-lg-4 col-sm-12">
                            <div class="row">
                                <label class="col-sm-4 col col-form-label">Project Source:</label>
                                <div class="col-sm-8 col">
                                    <p class="mb-0 pt-2 font-weight-bold">{{comdata?.ProjectSourceName}}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="" *ngIf="isCollapsed">
                        <div class="form-row">
                            <div class="form-group col-lg-4 col-sm-12">
                                <div class="row">
                                    <label class="col-sm-4 col col-form-label">Territory:</label>
                                    <div class="col-sm-8 col">
                                        <p class="mb-0 pt-2 font-weight-bold">{{comdata?.TerritoryName}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-lg-4 col-sm-12">
                                <div class="row">
                                    <label class="col-sm-4 col col-form-label">Closed Date:</label>
                                    <div class="col-sm-8 col">
                                        <p class="mb-0 pt-2 font-weight-bold">{{comdata?.CloseDate}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-lg-4 col-sm-12">
                                <div class="row">
                                    <label class="col-sm-4 col col-form-label">Quotation Engineer:</label>
                                    <div class="col-sm-8 col">
                                        <p class="mb-0 pt-2 font-weight-bold">
                                            {{comdata?.QuotationEngineerUser}}<br>({{comdata?.QuotationEngineerEmployeeId}})
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-row odd">
                            <div class="form-group col-lg-4 col-sm-12">
                                <div class="row">
                                    <label class="col-sm-4 col col-form-label">Sales Engineer:</label>
                                    <div class="col-sm-8 col">
                                        <p class="mb-0 pt-2 font-weight-bold">
                                            {{comdata?.SalesEngineerUser}}<br />({{comdata?.SalesEngineerEmployeeId}})
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-lg-4 col-sm-12">
                                <div class="row">
                                    <label class="col-sm-4 col col-form-label">Created By:</label>
                                    <div class="col-sm-8 col">
                                        <p class="mb-0 pt-2 font-weight-bold">{{comdata?.UserName}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-lg-4 col-sm-12">
                                <div class="row">
                                    <label class="col-sm-4 col col-form-label">Created Date:</label>
                                    <div class="col-sm-8 col">
                                        <p class="mb-0 pt-2 font-weight-bold">{{comdata?.CreatedDate}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-lg-4 col-sm-12">
                                <div class="row">
                                    <label class="col-sm-4 col col-form-labelt">Status:</label>
                                    <div class="col-sm-8 col">
                                        <p class="mb-0 pt-2 font-weight-bold">{{comdata?.ProjectStatusName}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr>
                    </div>

                    <div class="form-row">
                        <div class="col-md-12 mt-2">
                            <ngb-tabset #t="ngbTabset">
                                <ngb-tab id="tab-selectbyid1" title="Inquiry">
                                    <ng-template ngbTabContent>
                                        <div class="table-responsive">
                                            <div
                                                class="d-flex justify-content-between w-100 pt-3 pb-2 align-items-center">
                                                <mat-form-field
                                                    class="example-full-width pb-0 w-100 form-control-design1"
                                                    appearance="fill" style="max-width: 240px !important;">
                                                    <input #inputField matInput class="text-limit  pos-search"
                                                        [(ngModel)]="searchword" formControlName="SearchWord"
                                                        placeholder="Search" (keyup.enter)="applyFilter()" />
                                                    <span class="mdi mdi-magnify mdi-2x cursor-pointer " title="Search"
                                                        style="position: absolute;right: 0;font-size: 20px;color: #999;top: 0;"
                                                        (click)="applyFilter();">
                                                    </span>
                                                    <span class="position-absolute"
                                                        style="top: 50%; right: 7%; transform: translate(-50%, -50%);"
                                                        title="Clear">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                            fill="currentColor" class="bi bi-x" viewBox="0 0 16 16"
                                                            (click)="clearUserData(); applyFilter()"
                                                            (clearEvent)="searchword=''" *ngIf="searchword">
                                                            <path
                                                                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                                        </svg>
                                                    </span>
                                                </mat-form-field>
                                                <a href="javascript:void(0);" routerLink="/inquiry/addinquiry"
                                                    class="btn btn-info btn-sm ml-3">+
                                                    Add Inquiry</a>
                                            </div>
                                            <table class="table" mat-table matSorts [dataSource]="dataSource" matSort
                                                [matSortActive]="'name'" [matSortDisableClear]="true" aria-hidden="true"
                                                [matSortDirection]="'asc'" [multiTemplateDataRows]="true"
                                                (matSortChange)="onSortData($event)">
                                                <ng-container matColumnDef="InquiryName">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        Inquiry Name (Inquiry Id)<img src="assets/images/sort_both.png"
                                                            *ngIf="columnsort!='InquiryName'" alt=""><img
                                                            src="assets/images/sort_up.png" alt=""
                                                            *ngIf="upicon && !downicon && columnsort =='InquiryName'"><img
                                                            src="assets/images/sort_down.png" alt=""
                                                            *ngIf="downicon && !upicon && columnsort =='InquiryName'">
                                                    </th>
                                                    <td mat-cell *matCellDef="let element"><a
                                                            *ngIf="permission.Inquiry_View==1 || userRId==1"
                                                            href="javascript:void(0);"
                                                            (click)="view(element.InquiryId)">{{element['InquiryName']}}<br />
                                                            <small>({{element['InquiryNumber']}})</small></a>
                                                    </td>
                                                </ng-container>

                                                <ng-container matColumnDef="CustomerName">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        Customer Name<img src="assets/images/sort_both.png" alt=""
                                                            *ngIf="columnsort!='CustomerName'"><img
                                                            src="assets/images/sort_up.png" alt=""
                                                            *ngIf="upicon && !downicon && columnsort =='CustomerName'"><img
                                                            src="assets/images/sort_down.png" alt=""
                                                            *ngIf="downicon && !upicon && columnsort =='CustomerName'">
                                                    </th>
                                                    <td mat-cell *matCellDef="let element">
                                                        {{element['CompanyName']}}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="Stage">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        Stage<img src="assets/images/sort_both.png" alt=""
                                                            *ngIf="columnsort!='Stage'"><img
                                                            src="assets/images/sort_up.png" alt=""
                                                            *ngIf="upicon && !downicon && columnsort =='Stage'"><img
                                                            src="assets/images/sort_down.png" alt=""
                                                            *ngIf="downicon && !upicon && columnsort =='Stage'">
                                                    </th>
                                                    <td mat-cell *matCellDef="let element">
                                                        {{element['StageName']}}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="QuotedDate">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Quoted
                                                        Date<img src="assets/images/sort_both.png" alt=""
                                                            *ngIf="columnsort!='QuotedDate'"><img
                                                            src="assets/images/sort_up.png" alt=""
                                                            *ngIf="upicon && !downicon && columnsort =='QuotedDate'"><img
                                                            src="assets/images/sort_down.png" alt=""
                                                            *ngIf="downicon && !upicon && columnsort =='QuotedDate'">
                                                    </th>
                                                    <td mat-cell *matCellDef="let element">
                                                        {{element['QuotedDate']}}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="QuotedValue">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Total
                                                        Quoted Value<img src="assets/images/sort_both.png" alt=""
                                                            *ngIf="columnsort!='QuotedValue'"><img
                                                            src="assets/images/sort_up.png" alt=""
                                                            *ngIf="upicon && !downicon && columnsort =='QuotedValue'"><img
                                                            src="assets/images/sort_down.png" alt=""
                                                            *ngIf="downicon && !upicon && columnsort =='QuotedValue'">
                                                    </th>
                                                    <td mat-cell *matCellDef="let element">
                                                        {{element['QuotedValue']}}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="ReportedValue">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Total
                                                        Reported Value<img src="assets/images/sort_both.png" alt=""
                                                            *ngIf="columnsort!='ReportedValue'"><img
                                                            src="assets/images/sort_up.png" alt=""
                                                            *ngIf="upicon && !downicon && columnsort =='ReportedValue'"><img
                                                            src="assets/images/sort_down.png" alt=""
                                                            *ngIf="downicon && !upicon && columnsort =='ReportedValue'">
                                                    </th>
                                                    <td mat-cell *matCellDef="let element">
                                                        {{element['ReportedValue']}}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="BussinessVerticals">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        Bussiness Verticals<img src="assets/images/sort_both.png" alt=""
                                                            *ngIf="columnsort!='BussinessVerticals'"><img
                                                            src="assets/images/sort_up.png" alt=""
                                                            *ngIf="upicon && !downicon && columnsort =='BussinessVerticals'"><img
                                                            src="assets/images/sort_down.png" alt=""
                                                            *ngIf="downicon && !upicon && columnsort =='BussinessVerticals'">
                                                    </th>
                                                    <td mat-cell *matCellDef="let element">
                                                        {{element['BusinessVerticalName']}}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="QuotationEngineer">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        Quotation Engineer<img src="assets/images/sort_both.png"
                                                            *ngIf="columnsort!='QuotationEngineer'" alt=""><img
                                                            src="assets/images/sort_up.png" alt=""
                                                            *ngIf="upicon && !downicon && columnsort =='QuotationEngineer'"><img
                                                            src="assets/images/sort_down.png" alt=""
                                                            *ngIf="downicon && !upicon && columnsort =='QuotationEngineer'">
                                                    </th>
                                                    <td mat-cell *matCellDef="let element">
                                                        {{element['QuotationEngineerUserName']}}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="SalesEngineer">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Sales
                                                        Engineer<img src="assets/images/sort_both.png"
                                                            *ngIf="columnsort!='SalesEngineer'" alt=""><img
                                                            src="assets/images/sort_up.png" alt=""
                                                            *ngIf="upicon && !downicon && columnsort =='SalesEngineer'"><img
                                                            src="assets/images/sort_down.png" alt=""
                                                            *ngIf="downicon && !upicon && columnsort =='SalesEngineer'">
                                                    </th>
                                                    <td mat-cell *matCellDef="let element">
                                                        {{element['SalesEngineerUserName']}}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="ExpOrderDate">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Exp.
                                                        Order Date<img src="assets/images/sort_both.png" alt=""
                                                            *ngIf="columnsort!='ExpOrderDate'"><img
                                                            src="assets/images/sort_up.png" alt=""
                                                            *ngIf="upicon && !downicon && columnsort =='ExpOrderDate'"><img
                                                            src="assets/images/sort_down.png" alt=""
                                                            *ngIf="downicon && !upicon && columnsort =='ExpOrderDate'">
                                                    </th>
                                                    <td mat-cell *matCellDef="let element">
                                                        {{element['ExpOrderDate']}}</td>
                                                </ng-container>

                                                <tr class="odd" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                                <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                                                </tr>
                                            </table>
                                            <div *ngIf="TotalRecord == 0" class="text-center">
                                                No Record found.
                                            </div>
                                            <div *ngIf="TotalRecord > 0">
                                                <mat-paginator #paginator [pageSizeOptions]="[10, 20, 50, 100]"
                                                    [length]="totalSize" showFirstLastButtons
                                                    aria-label="Select page of periodic elements"
                                                    [pageIndex]="currentPage" (page)="handlePage($event)"
                                                    [pageSize]="pageSize">
                                                </mat-paginator>
                                            </div>
                                        </div>
                                    </ng-template>
                                </ngb-tab>

                                <ngb-tab id="tab-selectbyid3">
                                    <ng-template ngbTabTitle>Activity History</ng-template>
                                    <ng-template ngbTabContent>
                                        <div class="activity-history mt-3">
                                            <ul>
                                                <li *ngFor="let history of activityhistory">
                                                    <div><span><i
                                                                class="fa fa-calendar-check-o"></i>{{history.CreatedDate}}
                                                        </span> <i class="fa fa-user-circle"></i> {{history.userName}}
                                                    </div>
                                                    <p>{{history.Activity}}</p>
                                                </li>
                                                <li *ngIf="activityhistory==''">
                                                    <div></div>
                                                    <p class="text-center">No Data Found</p>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="spinner-border" role="status" *ngIf="loader">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                        <div class="text-center position-relative" *ngIf="showMore">
                                            <a href="javascript:void(0);" (click)="showMoreactivity()"
                                                class="read-more read-more-top new-show-less" placement="top">
                                                <span> <img src="{{default}}" class="img-fluid" alt="..." width="21">
                                                    Show More </span>
                                            </a>
                                        </div>
                                    </ng-template>
                                </ngb-tab>
                            </ngb-tabset>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>